// extracted by mini-css-extract-plugin
module.exports = {"svg":"LoadingIcon-module__svg--x3JxP","rotate":"LoadingIcon-module__rotate--24VaW","circle":"LoadingIcon-module__circle--2i4sG","dash":"LoadingIcon-module__dash--11KXh"};